<template>
  <div class="containter-custom">
    <div class="md-layout md-alignment-center-center vh100 m-tb-minus-40">
      <div class="auth_logo pt-60 mt-20 mb--10"><img class="auth_logo" :src="logoNew" /></div>
      <md-card class="mt-minus-25 md-layout-item md-size-40 md-small-size-100 bg_w rounded pt-40 pb-60 pl-30 pr-30">
        <md-card-header class="pt-0">
          <h3 class="center bold mb-0">Passwort zurücksetzen</h3>
          <p v-if="status === 'valid'" class="center">
            für {{ username }}
          </p>
        </md-card-header>

        <md-card-content class="pt-30">
          <!-- countdown timer -->
          <div v-if="status === 'valid'" class="center timer">
            Zeit bis Ablauf: {{ remainingDisplay }}
          </div>

          <div v-if="status==='verifying'" class="auth-loading">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            Überprüfe Link…
          </div>

          <div v-else-if="status==='invalid'" class="center">
            Dieser Link ist {{ error }}.
          </div>

          <form v-else @submit.prevent="onSubmit">
            <div class="relative">
              <md-field class="md-focused">
                <label>Neues Passwort</label>
                <md-input
                    type="password"
                    v-model.trim="password"
                    @input="validate"
                    :disabled="submitting"
                />
              </md-field>
            </div>

            <p class="pt-30">
              <md-field class="md-focused">
                <label>Passwort bestätigen</label>
                <md-input
                    type="password"
                    v-model.trim="confirm"
                    @input="validate"
                    :disabled="submitting"
                />
              </md-field>
            </p>

            <p class="alert center" v-if="error">{{ error }}</p>
          </form>
        </md-card-content>

        <md-card-actions v-if="status === 'valid'" class="justify-center pb-20">
          <md-button type="submit" class="md-raised md-primary" @click="onSubmit" :disabled="!canSubmit || submitting">
            {{ submitting ? 'Bitte warten…' : 'Passwort ändern' }}
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const url = process.env.VUE_APP_API_URL;

export default {
  name: 'ResetPassword',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      logoNew: null,
      status: 'verifying',  // verifying | valid | invalid
      password: '',
      confirm: '',
      username: '',
      expiresAt: null,      // timestamp in ms
      remaining: 0,         // milliseconds
      timerId: null,
      canSubmit: false,
      error: '',
      submitting: false,
      code: ''
    };
  },
  computed: {
    remainingDisplay() {
      if (this.remaining <= 0) return '00:00';
      const totalSec = Math.floor(this.remaining / 1000);
      const hrs = Math.floor(totalSec / 3600);
      const mins = Math.floor((totalSec % 3600) / 60);
      const secs = totalSec % 60;
      const pad = n => n.toString().padStart(2, '0');
      return hrs > 0
          ? `${pad(hrs)}:${pad(mins)}:${pad(secs)}`
          : `${pad(mins)}:${pad(secs)}`;
    }
  },
  created() {
    this.code = this.$route.query.code || '';
  },
  async mounted() {
    // Load background + logo immediately (same as SignIn / PasswordHelp)
    let self = this;
    await this.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        // Background/logo not critical — continue
      } else {
        let result = res.data.data[0];
        self.logoNew = result.baseLogo;
        self.logoBack = process.env.VUE_APP_CRM_URL + "/titleImgs/file." + result.logoback;
        document.getElementsByClassName("containter-custom")[0].style.cssText = `background-image: url(${self.logoBack})`;
      }
    });

    const data = this.encodeData({ code: this.code });
    try {
      const r = await axios.post(`${url}activationCodeVerify`, { data });
      const decoded_data = this.decodeData(r.data.data);
      if (!decoded_data.error) {
        this.status = 'valid';
        this.username = decoded_data.activation.username;
        this.expiresAt = new Date(decoded_data.activation.activation_expires).getTime();
        this.remaining = this.expiresAt - Date.now();
        this.timerId = setInterval(() => {
          this.remaining = this.expiresAt - Date.now();
          if (this.remaining <= 0) {
            clearInterval(this.timerId);
            this.status = 'invalid';
            this.error = 'abgelaufen';
          }
        }, 1000);
      } else {
        this.status = 'invalid';
        this.error = decoded_data.error;
      }
    } catch (e) {
      this.status = 'invalid';
      this.error = e.message || 'Something went wrong';
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    validate() {
      this.error = '';
      if (!this.password || !this.confirm) {
        this.canSubmit = false;
        return;
      }
      if (this.password !== this.confirm) {
        this.error = 'Passwörter stimmen nicht überein.';
        this.canSubmit = false;
        return;
      }
      this.canSubmit = true;
    },
    async onSubmit() {
      if (!this.canSubmit) return;
      this.submitting = true;
      const data = this.encodeData({
        code: this.code,
        newPassword: this.password
      });
      try {
        await axios.post(`${url}changePasswordWithCode`, { data }).then((response) => {
          this.$router.push('/signin');
        });
      } catch (err) {
        this.error = err.response?.data?.msg || 'Fehler beim Ändern des Passworts.';
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>


<style>
.containter-custom {
  width: 100%;
  min-height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
img.auth_logo {
  max-width: 200px !important;
  max-height: 200px !important;
  padding-bottom: 20px;
  margin: auto;
}
.auth-loading {
  text-align: center;
  margin: 2rem 0;
}
.auth-error {
  color: red;
  margin: 0.5rem 0 1rem;
}
</style>
